export const INSP_GALLERY_ELEMENT_BLOCK = 'ggr';
